import type { Asset } from '#/graphql/types';
import useWOTemplateListQuery from './useWOTemplateListQuery';

const useWOTemplateForAsset = (asset?: Asset) => {
  const tenantQuery = ['tenantId', '=', asset?.tenantId];

  const assetTypeOnly = [
    ['assetTypeId', '=', asset?.assetTypeId ?? ''],
    'AND',
    ['manufacturer.id', 'isNull'],
    'AND',
    ['model.id', 'isNull'],
  ];

  const assetTypeAndManufacturer = [
    ['assetTypeId', '=', asset?.assetTypeId ?? ''],
    'AND',
    ['manufacturer.id', '=', asset?.makeId ?? ''],
    'AND',
    ['model.id', 'isNull'],
  ];

  const exactMatch = [
    ['assetTypeId', '=', asset?.assetTypeId ?? ''],
    'AND',
    ['manufacturer.id', '=', asset?.makeId ?? ''],
    'AND',
    ['model.id', '=', asset?.modelId ?? ''],
  ];

  const filterObject = [
    tenantQuery,
    'AND',
    [assetTypeOnly, 'OR', assetTypeAndManufacturer, 'OR', exactMatch],
  ];

  const q = useWOTemplateListQuery({
    params: {
      filter: JSON.stringify(filterObject),
    },
  });

  return q;
};

export default useWOTemplateForAsset;
